<template>
	<div class="c-radio" :class="[{'z-chk': checkState}, `s-${skin}`]" @click="checkHandle(true)">
		<div></div>
		<span v-if="$slots.default"><slot></slot></span>
	</div>
</template>

<script>
	export default {
		name: 'cRadio',
		
		props: {
			checked: Boolean,
			
			value: [Number, String],
			
			skin: String
		},

		data() {
			return {
				checkState: !!this.checked
			};
		},

		watch: {
			checked(val) {
				this.checkState = !!val;
			},
			
			checkState(val) {
				this.$emit('change', val);
				
				if (val && this.$parent.$options.name == 'cRadioGroup') {
					this.$parent.checkHandle(this.value);
				}
			}
		},

		methods: {
			checkHandle(state) {
				this.checkState = state;
				this.$emit('click', state);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-radio {
		display: inline-block;
		
		&:not(.s-tab) {
			height: 20px;
			font-size: 13px;
			overflow: hidden;
			cursor: pointer;
			
			elder({
				height: 30px,
				font-size: 23px
			})
			
			&:hover {
				div {
					border-color: #bbb;
				}
			}

			&.z-chk {
				div {
					border-color: #000;
					
					&:after {
						width: 9px;
						height: 9px;
						
						elder({
							width: 14px,
							height: 14px
						})
					}
				}
				
				span {
					font-weight: bold;
				}
			}

			div {
				float: left;
				position: relative;
				width: 18px;
				height: 18px;
				border: 1px solid #ddd;
				border-radius: 100%;
				background: #fff;
				transition: all .1s ease;
				
				elder({
					width: 28px,
					height: 28px
				})
				
				&:after {
					content: '';
					position: absolute;
					left: 50%;
					top: 50%;
					width: 0;
					height: 0;
					border-radius: 100%;
					background: #000;
					transform: translate(-50%,-50%);
					transition: all .1s ease;
				}
			}
			
			span {
				float: left;
				margin-left: 5px;
				line-height: 18px;
				
				elder({
					margin-left: 10px,
					line-height: 30px
				})
			}
		}
		
		&.s-tab {
			position: relative;
			box-sizing: border-box;
			min-width: 8em;
			height: 40px;
			border: 2px solid #ddd;
			padding: 0 26px;
			line-height: 35px;
			font-size: 15px;
			text-align: center;
			color: #444;
			cursor: pointer;
			
			elder({
				height: 50px,
				font-size: 20px,
				line-height: 45px
			})
			
			&.z-chk,
			&:hover {
				border-color: #1492FF;
				color: #1492FF;
			}
			
			&.z-chk:after {
				content: '';
				position: absolute;
				right: 0;
				bottom 0;
				width: 30px;
				height: 30px;
				background-image: url('~@/assets/image/z_crt.png');
				background-size: 100%;
			}
		}
	}
</style>
